export const apiConfig = {
  invitationApiUrls: {
    qrcode: "qrcode",
  },
  assessmentApiUrls: {
    assessment: "assessment",
    assessmentAnswer: "assessment/answer",
    assessmentResult: "assessment/result",
    courseSubject: "course/subject",
    announcement: "announcement",
    entityAssessmentAssessment: "entity-assessment/assessment",
    entityAssessmentAnswer: "entity-assessment/answer",
  },
  sessionAttendanceApiUrls: {
    attendanceSessions: "attendance/sessions",
    attendance: "attendance",
  },
  authenticationApiUrls: {
    student: "student",
    applicationConfiguration: "application/configuration",
    emailPreference: "email_preference",
  },
  cbmeApiUrls: {
    competencyAssets: "competency/assets",
    competencyVideo: "competency/video",
    competencyIntegration: "competency/integration",
    assignment: "assignment",
    search: "search",
    competencyDocument: "competency/document",
  },
  courseApiUrls: {
    course: "course",
    subjectChapter: "subject/chapter",
    chapterTopic: "chapter/topic",
    topicSubtopic: "topic/subtopic",
    groups: "groups",
    search: "search",
    studymaterial: "studymaterial",
    assessment: "assessment",
    assignmentWork: "assignment/work",
    assignment: "assignment",
    educatorReport: "educator-report",
    forum: "forum",
    educatorDashboard: "educator-dashboard",
    student: "student",
    videoStudent: "video/student",
    logbook: "logbook",
    logbookActivity: "logbook/activity",
    educator: "educator",
    logbookAsset: "logbook/asset",
  },
  courseViewApiUrls: {
    studentSubject: "student/subject",
    studentChapter: "student/chapter",
    educatorVideo: "educator/video",
  },
  dashboardApiUrls: {
    studentDashboard: "student/dashboard",
    studymaterial: "studymaterial",
  },
  dropdownFiltersApiUrls: {
    course: "course",
    subject: "subject",
    courseSubject: "course/subject",
    subjectChapter: "subject/chapter",
    chapterTopic: "chapter/topic",
    topicSubtopic: "topic/subtopic",
  },
  filtersApiUrls: {
    educator: "educator",
    assignment: "assignment",
    studymaterialSearch: "studymaterial/search",
    search: "search",
    mcontent: "mcontent",
    videoSearch: "video/search",
    meeting: "meeting",
    bbbRecord: "bbb-record",
  },
  liveClassApiUrls: {
    webxMeeting: "webx/meeting",
    zoomMeeting: "zoom/meeting",
    meetingJoin: "meeting/join",
    groups: "groups",
    search: "search",
  },
  presentationClassApiUrls: {
    presentation: "presentation",
  },
  productionvideosApiUrls: {
    video: "video",
    mcontent: "mcontent",
  },
  publicApiUrls: {
    audit: "audit",
  },
  sidenavApiUrls: {
    student: "student",
    groups: "groups",
  },
  studymaterialApiUrls: {
    mcontent: "mcontent",
    courseSubject: "course/subject",
    cbmeTopic: "cbme/topic",
    cbmeCompetency: "cbme/competency",
    cbmeSlo: "cbme/slo",
    videoStudent: "video/student",
    studentDashboard: "student/dashboard",
    studymaterial: "studymaterial",
    assignmentWork: "assignment/work",
    report: "report",
    assessment: "assessment",
    studentAssignment: "student/assignment",
    assignment: "assignment",
    forum: "forum",
    bbbRecord: "bbb-record",
    attendance: "attendance",
    search: "search",
  },
  subjectdisplayApiUrls: {
    educatorVideo: "educator/video",
    educatorSubject: "educator/subject",
    subjectChapter: "subject/chapter",
    chapterTopic: "chapter/topic",
    topicSubtopic: "topic/subtopic",
    videoModel: "video/model",
    model: "model",
    presentation: "presentation",
    educatorReport: "educator-report",
    report: "report",
    videoRatings: "video/ratings",
  },
  ticketApiUrls: {
    ticket: "ticket",
    ticketConversation: "ticket/conversation",
  },
  uploadToS3ApiUrls: {
    videoStudent: "video/student",
    video: "video",
  },
  videoApiUrls: {
    videoMcq: "video/mcq",
    videoMcqAnswer: "video/mcq/answer",
    history: "history",
    videoFeedback: "video/feedback",
    videoHistory: "video/history"
  },
  viewProfileApiUrls: {
    student: "student",
    collegeDocument: "college/document",
    collegeStudentDocument: "college/student/document",
    examination: "examination",
    collegeStudentMarkscard: "college/student/markscard",
  },
  timetableApiUrl: {
    timetable: "timetable",
    feedback: "timetable/feedback",
  },
  ugPreparation: {
    ugexam: "ug-exam",
    ugquestionpaper: "ug-exam/question-paper",
  },
  pgPreparation: {
    ReadAssessment: "pg-exam/mcq",
    mcqQuestionsSubmit: "pg-exam/mcq/answer",
    assessmentResults: "pg-exam/mcq/result",
    pgExamVideos: "pg-exam/video",
    pgExamNote: "pg-exam/note",
  },
  clinialCasesUrls: {
    cases: "clinical-case",
    clinicalCaseAsset: "clinical-case/asset",
  },
  bookStoreApiUrls : {
    book: 'book',
    bookHistory: 'book/history'
  }
};